export default __webpack_public_path__ + "static/awarepath_small-image_2-543ae2b8429d896e86645edd72e16c31.png";